import { inject, Injectable } from '@angular/core';
import { FIREBASE_PROJECT_ID_PROVIDER } from '@principle-theorem/ng-shared';
import {
  getFirestoreLink,
  isWithRef,
  snapshot,
} from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import { ManagementToolSidebarService } from '../management-tool-sidebar.service';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';

@Injectable({ providedIn: 'root' })
export class OpenInFirestoreTool implements IManagementTool {
  private _sidebarService = inject(ManagementToolSidebarService);
  private _projectId = inject(FIREBASE_PROJECT_ID_PROVIDER);

  readonly name = 'open-in-firestore';
  readonly label = 'Open in Firestore';
  readonly icon = 'database';
  readonly description = 'Open this document in GCP Firestore Console';
  readonly resource = ManagementResource.WithRef;

  async isHidden(_context: IToolRunContext): Promise<boolean> {
    const showDevTools = await snapshot(this._sidebarService.showDevTools$);
    return !showDevTools;
  }

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value || !isWithRef(value)) {
      return;
    }
    const url = getFirestoreLink(this._projectId, value.ref);
    window.open(url, '_blank');
  }
}
